import { useTypedSelector } from "ui/hooks/useTypeSelector";

export const useAuthorized = () => {
  const { authorized } = useTypedSelector((state) => state.auth);

  return { authorized };
};

export default useAuthorized;
